import { DocumentCountryType } from 'src/Libs/document.service'
import { DownloadCategoryItemDto, DownloadFileItemDto, DownloadsSearchResultDto } from '../dto'
import { DownloadFileItem, DownloadsCategoryModel, DownloadsSearchResult } from '../models/downloads.model'

export const downloadsCategoryDtoToModelTransformer = (dto: DownloadCategoryItemDto): DownloadsCategoryModel => {
  return {
    ...dto,
    children: dto.children.map(child => {
      if (child.type === 'file') {
        return {
          ...child,
          countryList: child.countryList as DocumentCountryType[],
        }
      } else {
        return {
          ...child,
        }
      }
    }),
  }
}

export const downloadsSearchResultDtoToModelTransformer = (dto: DownloadsSearchResultDto): DownloadsSearchResult => {
  return {
    ...dto,
    countryList: dto.countryList as DocumentCountryType[],
  }
}

export const downloadsItemDtoToModelTransformer = (dto: DownloadFileItemDto): DownloadFileItem => {
  return {
    ...dto,
    countryList: dto.countryList as DocumentCountryType[],
  }
}
